function addValidationStateToShortDescription(validationState, shortDescription) {
  if (validationState === "correct") {
    shortDescription = (shortDescription ? shortDescription + " " : "") + "(Correct)";
  } else if (validationState === "incorrect") {
    shortDescription = (shortDescription ? shortDescription + " " : "") + "(Incorrect)";
  } else if (validationState === "partialcorrect") {
    shortDescription = (shortDescription ? shortDescription + " " : "") + "(Partially correct)";
  }
  return shortDescription;
}
export {
  addValidationStateToShortDescription as a
};
